export const divisionTag = 'division:';
